<template>
  <b-modal
    id="creative-type-modal"
    size="lg"
    header-class="d-block pb-1"
    centered
    ok-variant="success"
    ok-title="Confirm"
    @ok="confirm"
    :ok-disabled="!isSelectionValid"
    cancel-variant="tertiary mr-3"
    cancel-title="Back"
    @cancel="$emit('previous-step')"
    :no-close-on-esc="true"
  >
    <template v-slot:modal-header>
      <base-help-tooltip>
        <template slot="left">
          <h4 class="modal-title mb-3">
            Please Select Creative Type
          </h4>
        </template>
        <template slot="popover-body">
          <p>
            To be added later
          </p>
        </template>
      </base-help-tooltip>
    </template>
    <creative-type
      :is-modal-view="true"
    />
  </b-modal>
</template>

<script>

import CreativeType from '@/modules/content/components/CreativesPage/Sidebar/CreativeType/CreativeType';
import BaseHelpTooltip from '@/components/BaseHelpTooltip';
import {
  mapActions, mapState,
} from 'vuex';
import * as contentTypes from '@/modules/content/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'CreativeTypeModal',
  components: { BaseHelpTooltip, CreativeType },
  computed: {
    ...mapState('content', [
      'adUnitsSelected',
      'creativeTypeSelected',
    ]),
    ...mapState('templates', [
      'selectedTemplates',
      'selectedGroup',
    ]),
    isSelectionValid() {
      if (this.creativeTypeSelected !== 'TEMPLATE_GROUP') {
        return this.creativeTypeSelected && this.adUnitsSelected.length > 0;
      }
      return this.selectedGroup && this.selectedTemplates.length > 0;
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.PATCH_CAMPAIGN,
    ]),
    ...mapActions('content', [
      contentTypes.POST_CREATIVES,
      contentTypes.POST_CREATIVES_WITH_TYPE,
    ]),
    async confirm() {
      if (this.creativeTypeSelected !== 'TEMPLATE_GROUP') await this.POST_CREATIVES_WITH_TYPE();
      else {
        await this.PATCH_CAMPAIGN({ templateGroupId: this.selectedGroup.id });
        await this.POST_CREATIVES({ creatives: this.buildCreativeRequestList() });
      }
    },
    buildCreativeRequestList() {
      return this.selectedTemplates.map((templateId) => ({
        creativeTemplateId: templateId,
        isPaused: false,
      }));
    },
  },
};
</script>
<style scoped lang="scss">
</style>
